var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectsWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307.326,
    height: 137.75,
    viewBox: "0 0 81.313 36.446",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m322.977 460.22 232.257-1.224-.556-105.311-232.256 1.224z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.972 459.215 554.228 458l-.544-103.297-230.257 1.214z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m323.427 355.918 230.257-1.214.544 103.297-230.256 1.214z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m295.569 542.19 287.935-1.518-1.434-271.997-287.935 1.517z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h842v595H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -114.111 161.995)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.006 356.847-.42-.961.42.96",
    style: {
      fill: "#bd0b4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.054 459.198c-2.121.011-3.623-2.947-2.938-5.788l10.035-41.639c.564-2.337.55-4.88-.041-7.21l-10.462-41.308c-.718-2.834.754-5.813 2.876-5.824h.001l32.792-.15c1.306-.005 2.475 1.157 2.918 2.9l11.23 44.152a15.24 15.24 0 0 1 .038 7.253l-10.82 44.498c-.425 1.747-1.582 2.92-2.888 2.928l-32.74.188h-.001zm1.327-5.736 30.702-.177L369.68 409.7a7.259 7.259 0 0 0-.019-3.443l-10.998-43.244-30.751.139 10.002 39.491c.897 3.541.92 7.448.063 11z",
    style: {
      fill: "#135698",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.091 458.25c-2.12.01-3.622-2.948-2.938-5.789l10.036-41.639c.563-2.337.548-4.88-.042-7.21l-10.461-41.308c-.718-2.834.753-5.813 2.876-5.824l32.792-.15c1.306-.005 2.476 1.157 2.919 2.9l11.229 44.152a15.24 15.24 0 0 1 .038 7.253l-10.82 44.498c-.424 1.747-1.581 2.92-2.888 2.928l-32.74.188zm1.327-5.737 30.702-.177 10.598-43.586a7.27 7.27 0 0 0-.019-3.444l-10.998-43.243-30.75.14 10.002 39.491c.896 3.541.918 7.446.062 10.998z",
    style: {
      fill: "#a8da3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.512 411.347-10.819 44.497c-.425 1.748-1.582 2.921-2.888 2.929l-32.74.188c-2.122.012-3.625-2.947-2.94-5.788l10.036-41.639c.563-2.338.548-4.88-.042-7.21l-10.461-41.308c-.718-2.836.754-5.815 2.877-5.825l32.791-.148c1.306-.006 2.476 1.155 2.918 2.898l11.23 44.153a15.24 15.24 0 0 1 .039 7.253",
    style: {
      fill: "#135698",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.522 411.11-10.82 44.497c-.424 1.748-1.582 2.92-2.888 2.929l-32.74.188c-2.122.012-3.625-2.947-2.94-5.788l10.036-41.64c.563-2.337.549-4.88-.041-7.21l-10.462-41.307c-.718-2.836.754-5.815 2.877-5.825l32.791-.149c1.307-.006 2.476 1.156 2.919 2.9l11.23 44.151a15.24 15.24 0 0 1 .038 7.254",
    style: {
      fill: "#78ccf0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.531 410.872-10.82 44.498c-.424 1.748-1.581 2.92-2.888 2.929l-32.74.187c-2.121.013-3.624-2.946-2.939-5.788l10.035-41.638c.564-2.338.549-4.88-.04-7.211l-10.463-41.308c-.718-2.835.755-5.815 2.877-5.824l32.792-.149c1.306-.006 2.476 1.156 2.918 2.899l11.23 44.152a15.24 15.24 0 0 1 .038 7.253",
    style: {
      fill: "#a8da3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsWelcome);
export default __webpack_public_path__ + "static/media/projects_welcome.ac649f2de5a5772798e61686b9d74524.svg";
export { ForwardRef as ReactComponent };